import React, { useState} from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { PlusCircle } from 'lucide-react';
import BranchModal from '../../../components/Modals/Client/BranchModal';
import BranchCard from '../../../components/Card/Client/Branch';
import { deleteBranchFromFrontendApp  } from '../../../actions/infrastructures';

const Branches = ({ appId, amplifyAppId,  branches = [], gitHubRepo }) => {
  const { projectId } = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();

  const handleDelete = (branchId) => {
    try {
      dispatch(deleteBranchFromFrontendApp(projectId, appId, branchId));
    } catch (error) {
      console.error('Failed to delete branch:', error);
    }
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-semibold text-gray-900">Branches</h2>
        <button
          onClick={() => setIsModalOpen(true)}
          className="inline-flex items-center px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-lg transition-colors duration-200 font-medium shadow-sm"
        >
          <PlusCircle className="w-5 h-5 mr-2" />
          New Branch
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {branches.map((branch) => (
          <BranchCard
            key={branch.branchId}
            branch={branch}
            onDelete={() => handleDelete(branch.branchId)}
          />
        ))}
        {(!branches || branches.length === 0) && (
          <div className="col-span-full flex items-center justify-center h-48 bg-white rounded-lg border border-gray-200">
            <div className="text-center">
              <h3 className="text-lg font-semibold text-gray-900 mb-1">
                No branches found
              </h3>
              <p className="text-gray-600">
                Get started by adding a new branch
              </p>
            </div>
          </div>
        )}
      </div>

      <BranchModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        appId={appId}
        gitHubRepo={gitHubRepo}
      />
    </div>
  );
};

export default Branches;
